import React from "react";

const Github = () => {
  return (
    <a
      href="https://github.com/duchaidev"
      target="_blank"
      rel="noreferrer"
      className="group px-[7px] py-1"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 22 22"
        fill="#fff"
        className="transition-all duration-300 group-hover:fill-green-300 fill-white"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.0003 0.166672C9.57767 0.166672 8.16895 0.446884 6.85459 0.99131C5.54023 1.53574 4.34597 2.33371 3.34 3.33968C1.30836 5.37133 0.166992 8.12683 0.166992 11C0.166992 15.7883 3.27616 19.8508 7.57699 21.2917C8.11866 21.3783 8.29199 21.0425 8.29199 20.75V18.9192C5.29116 19.5692 4.65199 17.4675 4.65199 17.4675C4.15366 16.2108 3.44949 15.875 3.44949 15.875C2.46366 15.2033 3.52533 15.225 3.52533 15.225C4.60866 15.3008 5.18283 16.3408 5.18283 16.3408C6.12533 17.9875 7.71783 17.5 8.33533 17.24C8.43283 16.5358 8.71449 16.0592 9.01783 15.7883C6.61283 15.5175 4.08866 14.5858 4.08866 10.4583C4.08866 9.25584 4.50033 8.29167 5.20449 7.52251C5.09616 7.25167 4.71699 6.12501 5.31283 4.66251C5.31283 4.66251 6.22283 4.37001 8.29199 5.76751C9.14783 5.52917 10.0795 5.41001 11.0003 5.41001C11.9212 5.41001 12.8528 5.52917 13.7087 5.76751C15.7778 4.37001 16.6878 4.66251 16.6878 4.66251C17.2837 6.12501 16.9045 7.25167 16.7962 7.52251C17.5003 8.29167 17.912 9.25584 17.912 10.4583C17.912 14.5967 15.377 15.5067 12.9612 15.7775C13.3512 16.1133 13.7087 16.7742 13.7087 17.7817V20.75C13.7087 21.0425 13.882 21.3892 14.4345 21.2917C18.7353 19.84 21.8337 15.7883 21.8337 11C21.8337 9.57735 21.5534 8.16863 21.009 6.85427C20.4646 5.53991 19.6666 4.34565 18.6606 3.33968C17.6547 2.33371 16.4604 1.53574 15.1461 0.99131C13.8317 0.446884 12.423 0.166672 11.0003 0.166672Z" />
      </svg>
    </a>
  );
};

export default Github;
